import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

import {
  coursesTableHeader,
  optionsStatus,
} from "~/pages/Editor/EditorCatalogEducationalPrograms/options";
import { localizedSortFieldForApi } from "~/shared/lib/localizedSortField";

const saveDate = (value: string | null) => {
  if (value) {
    return new Date(value).toISOString().split("T")[0];
  } else return "";
};

export const coursesSortFieldForApi = (field?: string) => {
  if (!field) return undefined;
  let base = field;
  if (field === "nameEn") base = "name";
  else if (field === "statusEn") base = "status";
  if (!coursesTableHeader.includes(base)) return undefined;
  return base;
};

export const getEditorCoursesColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
  lang?: string | null,
): ColumnsType<any> =>
  options.map((option) => {
    const apiKey = localizedSortFieldForApi(option, lang);
    const columnSortable = coursesTableHeader.includes(option);
    const sortOrderFor = (
      key: string,
      currentField?: string,
      currentType?: string,
    ): SortOrder | undefined => {
      if (currentField !== key) return undefined;
      if (currentType === "ASC") return "ascend";
      if (currentType === "DESC") return "descend";
      return undefined;
    };
    const sortOrder = columnSortable
      ? sortOrderFor(apiKey, sortField, sortType)
      : undefined;

    const baseColumn = {
      title: t(`cep.courses_table.${option}`),
      dataIndex: option,
      key: apiKey,
      sorter: columnSortable,
      sortOrder,
    };

    // Special width for name field
    if (option === "name") {
      return {
        ...baseColumn,
        width: 350,
        render: (value: any) => <span>{value}</span>,
      };
    }

    // Special render for status field
    if (option === "status") {
      return {
        ...baseColumn,
        render: (value: any) => {
          const statusOption = optionsStatus.find((el) => el.value === value);
          return <span>{statusOption ? statusOption.label : value}</span>;
        },
      };
    }

    // Special render for certificateValidityPeriod field
    if (option === "certificateValidityPeriod") {
      return {
        ...baseColumn,
        render: (value: any) => <span>{value ?? t("cep.unlimited")}</span>,
      };
    }

    // Special render for date fields
    if (option === "createdAt" || option === "updatedAt") {
      return {
        ...baseColumn,
        render: (value: any) => <span>{saveDate(value)}</span>,
      };
    }

    if (option === "levelId") {
      return {
        ...baseColumn,
        render: (value: any, record: any) => <span>{record.levelName}</span>,
      };
    }

    // Default render
    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
